module.exports = __webpack_public_path__ + "static/img/mtb_port_lg.acbd53e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/meet-the-browns-banner-campaign/mtb_port_lg.jpg
// module id = 261
// module chunks = 2